import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className="not-found-page">
            <h1>404</h1>
            <h3>The page you are looking for is not avilable.</h3>
        </div>
    );
};

export default NotFound;